<template>
  <div class="container-fluid">
    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />


        <div class="card">
          <div class="card-body row">
            <!-- Caché en attendant de trouver comment faire le lien avec l'ERP
              <div class="col-md-4 col-sm-12">
              <div class="card">
                <div class="card-header bg-gradient-bleu text-white">
                  Personnalisation
                </div>
                <div class="card-body">
                  <fieldset class="form-group">
                    <label :for="'logo' + currentEtab.eId">Photo ou logo de l'établissement</label>
                    <div class="img-wrapper">
                      <img v-if="currentEtab.logo" :id="'logo' + currentEtab.eId" class="img-logo" :src="currentEtab.logo">
                      <div v-else :id="'logo' + currentEtab.eId" class="img-logo"></div>
                      <div class="img-overlay">
                        <button class="btn bleuAgap" v-tooltip="{content: 'Ajouter un logo'}" style="transform:scale(0.7);border-radius:20px;"><i class="fas fa-plus" style="transform:scale(1.6);" /></button>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label :for="'gerant' + currentEtab.eId">Gérant(e) de l'établissement</label>
                    <input @focus="$event.target.select()" class="form-control" :id="'gerant' + currentEtab.eId" type="text" v-model="currentEtab.gerant">
                  </fieldset>
                  <fieldset class="form-group">
                    <label :for="'chef' + currentEtab.eId">Chef de cuisine</label>
                    <input @focus="$event.target.select()" class="form-control" :id="'chef' + currentEtab.eId" type="text" v-model="currentEtab.chef">
                  </fieldset>
                </div>
              </div>
            </div> -->

            <div class="col-lg-6 col-md-12">
              <div class="card">
                <div class="card-header bg-gradient-bleu text-white">
                  Coordonnées
                </div>
                <div class="card-body row">
                  <fieldset class="form-group col-sm-8">
                    <label :for="'RS' + currentEtab.eId">Raison Sociale</label>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'RS' + currentEtab.eId" type="text" v-model="currentEtab.eRS">
                    <div class="error" v-if="!$v.currentEtab.eRS.required">
                      Ce champ est requis
                    </div>
                    <div class="error" v-else-if="!$v.currentEtab.eRS.maxLength">
                      Ce champ est trop long (max. {{$v.currentEtab.eRS.$params.maxLength.max}} caractères)
                    </div>
                  </fieldset>
                  <fieldset class="form-group col-sm-4" v-show="profilIsAdmin">
                    <label :for="'AF' + currentEtab.eId">Code AF</label>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'AF' + currentEtab.eId" type="text" v-model="currentEtab.codeAF">
                  </fieldset>

                  <fieldset class="form-group col-sm-8">
                    <label :for="'adresse1' + currentEtab.eId">Adresse</label>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'adresse1' + currentEtab.eId" type="text" v-model="currentEtab.adresse1">
                    <div class="error" v-if="!$v.currentEtab.adresse1.maxLength">
                      Ce champ est trop long (max. {{$v.currentEtab.adresse1.$params.maxLength.max}} caractères)
                    </div>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'adresse2' + currentEtab.eId" type="text" v-model="currentEtab.adresse2">
                    <div class="error" v-if="!$v.currentEtab.adresse2.maxLength">
                      Ce champ est trop long (max. {{$v.currentEtab.adresse2.$params.maxLength.max}} caractères)
                    </div>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'adresse3' + currentEtab.eId" type="text" v-model="currentEtab.adresse3">
                    <div class="error" v-if="!$v.currentEtab.adresse3.maxLength">
                      Ce champ est trop long (max. {{$v.currentEtab.adresse3.$params.maxLength.max}} caractères)
                    </div>
                  </fieldset>
                  <div class="col-sm-4">
                    <fieldset class="form-group">
                      <label :for="'telephone' + currentEtab.eId">Téléphone</label>
                      <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'telephone' + currentEtab.eId" type="text" v-model="currentEtab.tel">
                      <div class="error" v-if="!$v.currentEtab.tel.maxLength">
                        Ce champ est trop long (max. {{$v.currentEtab.tel.$params.maxLength.max}} caractères)
                      </div>
                    </fieldset>
                    <fieldset class="form-group">
                      <label :for="'email' + currentEtab.eId">Email</label>
                      <input @focus="$event.target.select()" @input="hasMods = true;checkMail()" class="form-control" :id="'email' + currentEtab.eId" type="text" v-model="tmpMail">
                      <div class="error" v-if="erreurMail">
                        Adresse email invalide
                      </div>
                      <div class="error" v-else-if="!$v.tmpMail.maxLength">
                        Ce champ est trop long (max. {{$v.tmpMail.$params.maxLength.max}} caractères)
                      </div>
                    </fieldset>
                  </div>

                  <fieldset class="form-group col-sm-3">
                    <label :for="'CP' + currentEtab.eId">Code Postal</label>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'CP' + currentEtab.eId" type="text" v-model="currentEtab.codePostal">
                    <div class="error" v-if="!$v.currentEtab.codePostal.required">
                      Ce champ est requis
                    </div>
                    <div class="error" v-if="!$v.currentEtab.codePostal.numeric">
                      Ce champ doit être un nombre
                    </div>
                    <div class="error" v-else-if="!$v.currentEtab.codePostal.minLength">
                      Ce champ est trop court (min. {{$v.currentEtab.codePostal.$params.minLength.min}} caractères)
                    </div>
                    <div class="error" v-else-if="!$v.currentEtab.codePostal.maxLength">
                      Ce champ est trop long (max. {{$v.currentEtab.codePostal.$params.maxLength.max}} caractères)
                    </div>
                  </fieldset>
                  <fieldset class="form-group col-sm-5">
                    <label :for="'ville' + currentEtab.eId">Ville</label>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'ville' + currentEtab.eId" type="text" v-model="currentEtab.ville">
                    <div class="error" v-if="!$v.currentEtab.ville.maxLength">
                      Ce champ est trop long (max. {{$v.currentEtab.ville.$params.maxLength.max}} caractères)
                    </div>
                  </fieldset>
                  <fieldset class="form-group col-sm-4">
                    <label :for="'contact' + currentEtab.eId">Contact</label>
                    <input @focus="$event.target.select()" @input="hasMods = true" class="form-control" :id="'contact' + currentEtab.eId" type="text" v-model="currentEtab.contact">
                  </fieldset>
                  <fieldset class="form-group col-lg-12 col-md-12">
                    <label :for="'commentaire' + currentEtab.eId">Commentaire</label>
                    <textarea @focus="$event.target.select()" @input="hasMods = true" class="form-control" rows="4" :id="'commentaire' + currentEtab.eId" style="width:100%;" v-model="currentEtab.commentairePourToutFournisseur"></textarea>
                  </fieldset>
                </div>
              </div>
            </div>

            
            <div class="col-lg-6 col-md-12">
              <div class="card">
                <div class="card-header">
                  Liste des Contacts
                </div>
                <table class="table table-bordered table-sm text-center">
                  <thead class="table-header-secondary">
                    <th>Contact</th>
                    <th>Fonction</th>
                    <th>Email</th>
                    <th>Tel</th>
                  </thead>
                  <tbody>
                      <tr v-for="(contact, id) in utilisateurComplet.personnes" :key="id">
                        <td style="vertical-align: middle">
                          {{contact.prenom + " " + contact.nom}}
                        </td>
                        <td>
                          {{contact.fonction}}
                        </td>
                        <td style="vertical-align: middle">
                          {{contact.email}}
                        </td>
                        <td style="vertical-align: middle">
                          {{contact.tel}}
                        </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <div class="w-100"></div>

            <div class="w-100"></div>

          </div>
        </div>
      </div>
</template>
<script>
import BarreActions from '@/components/Divers/BarreActions'
import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators"
import { connecteData } from "@/mixins/connecteData"
import vm from "@/helpers/vm-toolkit-vue"
import { setInfosEtablissement, currentUserInfoComplet } from '@/api/gpao/user'
import { showAlerts } from "@/mixins/alerts"
export default {
  name: "profil",
  mixins: [connecteData, showAlerts],
  components: { BarreActions },
  data() {
    return {
      currentFournId: null,
      currentEtab: { eId: 0 ,objDS: {}},
      tmpMail: "",
      erreurMail: false,
      hasMods: false,
      lieux: [],
      structures: [],
      nouveauLieu: {},
      enEditionLieu: {},
      filtreLieux: "",
      lieuxTri: [],
      lieuxJours: [],
      utilisateurComplet: {},
      keyTri: 1,
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        enregistrer: {
          label: "Enregistrer",
          disabled: true,
          class: "btn-success",
          async methode(contexte) {
            contexte.saveEtab()
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ ]
          contexte.actions.barreDroite = [ contexte.actions.enregistrer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.enregistrer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }
      }
    }
  },
  computed: {
    infoModifiee() {
      return this.hasMods
    }
  },
  watch: {
    etabCourant(newEtab) {
      this.selectEtab(newEtab.eId)
    },
    infoModifiee() {
      this.actions.disable(this.actions, !this.infoModifiee)
    }
  },
  validations: {
    currentEtab: {
      eRS: { required, maxLength: maxLength(120) },
      adresse1: { maxLength: maxLength(80) },
      adresse2: { maxLength: maxLength(80) },
      adresse3: { maxLength: maxLength(80) },
      codePostal: { required, numeric, minLength: minLength(5), maxLength: maxLength(5) },
      ville: { maxLength: maxLength(80) },
      tel: { maxLength: maxLength(50) }
    },
    tmpMail: { maxLength: maxLength(50) }
  },
  methods: {
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    async selectEtab(etablissementId) {
      let result = await this.askSave()
      if (!result) {
        this.currentEtab = vm.clone(this.utilisateurCourant.etablissements.find(el => el.eId === etablissementId))
        this.currentEtab.objDS={}
        if (this.currentEtab.donneesSupplementaires) {
          this.currentEtab.objDS=JSON.parse( this.currentEtab.donneesSupplementaires)
        }
      
        this.hasMods = false
        this.nouveauLieu.etablissementId = this.currentEtab.eId
        this.tmpMail = this.currentEtab.email || ""
        this.chargerInfoComplet()
      }
    },
    checkMail() {
      if (this.tmpMail && !vm.is.email(this.tmpMail)) {
        this.erreurMail = true
      } else {
        this.currentEtab.email = this.tmpMail
        this.erreurMail = false
      }
      return !this.erreurMail
    },
    saveEtab() {
      setInfosEtablissement(this.currentEtab)
        .then(function () {
          this.$store.commit('user/setInfosEtablissement', this.currentEtab)
          this.hasMods = false
          this.toastSucces('Modifications enregistrées')
        }.bind(this))
        .catch(e => {
          console.error(e)
          this.toastErreur("Echec de l'enregistrement")
        })
    },
    async askSave() {
      if (!this.hasMods) {
        return Promise.resolve(false)
      }
      return this.alerteConfirmationEnregistrement()
    },
    async chargerInfoComplet() {
      let rep = await currentUserInfoComplet()
      this.utilisateurComplet = rep.data
    },

    
  },
  mounted() {
    this.actions.initialiser(this)  
  },
  created() {
    this.selectEtab(this.etabCourantId)
  },
  beforeRouteLeave(to, from, next) {
    console.log('checkRouteProfile')
    return this.askSave()
      .then(result => {
        if (result) {
          // Enregistrement de l'établissement
          this.saveEtab()
        }
        // eslint-disable-next-line promise/no-callback-in-promise
        next()
        return
      })
  }
}
</script>

<style scoped>

.nav.nav-tabs .nav-item a.nav-link.active {
  background-color: #4d80d1 !important;
  border-radius: 10px;
  border-width: 0;
  color: white !important;
}
.nav.nav-tabs.nav-linetriangle .nav-item a.nav-link.active {
  color: white !important;
}
.nav.nav-tabs .nav-item .nav-link {
  /* barre d'onglets' */
  background-color: white !important;
  border-radius: 10px;
  border-width: 0;
  color: #4d80d1;
}

.nav {
  border-width: 0;
  margin-bottom: 40px;
}
.nav.nav-tabs a.nav-link.active:before,
.nav.nav-tabs a.nav-link.active:after {
  border: none !important;
}
p {
  font-size: 12px;
  margin-bottom: 5px;
}
.img-wrapper {
  /* logo */
  position: relative;
}
.img-logo {
  border-radius: 60px;
  box-shadow: 2px 2px 2px 2px lightgrey;
  display: block;
  height: 120px;
  margin-left: auto;
  margin-right: auto;
  width: 120px;
}
.img-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}
.img-overlay:before {
  content: " ";
  display: block;
  height: 85%;
}
.ovale-agrement {
  fill: white;
  stroke:lightgray;
  stroke-width: 2;
}
#modalEditionJours td {
  text-align: center;
}
</style>
